import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { isSubscribedReselector as stateSelector } from 'reduxModules/users/selectors'
import { changeSubscriptionDispatchers as dispatcher } from 'reduxModules/users/dispatchers'
import SubscriptionPlanList from '../../SubscriptionPlans/SubscriptionPlanList'
import PLANS from '../../SubscriptionPlans/fixturePlans'
import './styles.css'

export function ChangeSubscription(props) {
  const { isSubscribed } = props
  return (
    <div
      id="ChangeSubscription"
      className="account-section wrapper"
    >
      <h3 className="account-section__title">
        {isSubscribed ? 'upgrade subscription plan' : 'choose your subscription plan'}
      </h3>
      <div className="message">
        <span>
          {isSubscribed ? 'To upgrade your subscription, select a new plan from the chart below.' : 'To start a subscription, select a plan from the chart below.'}
        </span>
      </div>
      <div className="personal-information">
        <SubscriptionPlanList
          plans={PLANS}
          upgrading
          currentPlan={isSubscribed ? props.subscription.rank : 0}
          currentPlanName={isSubscribed ? props.subscription.plan : ''}
          currentPlanId={isSubscribed ? props.subscription.planId : ''}
          isSubscribed={isSubscribed}
          changeSubscription
          upgradeAction={(plans, newPlan, oldPlan) => props.dispatchUpgradePlan(plans, newPlan, oldPlan)}
        />
      </div>
    </div>
  )
}

ChangeSubscription.propTypes = {
  isSubscribed: PropTypes.bool.isRequired
}

export default connect(
  stateSelector,
  dispatcher
)(ChangeSubscription)
